<script>
import Button from 'primevue/button';
import Toolbar from 'primevue/toolbar';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Card from 'primevue/card';
import Utils from '../../common/Utils';
import Constants from '../../common/Constants';
import Dialog from 'primevue/dialog';
import FileUpload from 'primevue/fileupload';

import GenericCustomMasterDataAutocompleteV2 from '../../components/generic/GenericCustomMasterDataAutocompleteV2.vue';
import TankManagementService from '../../services/tank-management';
import ResponsiveButton from '../../components/generic/ResponsiveButton.vue';

export default{
    props: [],
    components: { Button, Toolbar, DataTable, Column, Card, Dialog, FileUpload, GenericCustomMasterDataAutocompleteV2, ResponsiveButton },
    data(){
        return{
            tanks: [],
            details: [],
            selectedHeader: null,
            uploadDisplay: false,
            detailsDisplay: false,
            uploaded: [],
            uploaderResponse: false,
            selectedTank: {},
            api: null,
            dialogData: null,
            message: null,
        }
    },
    mounted(){
        this.$store.dispatch('security/setNavbarTitle', 'tankManagement.page_title');
    },
    computed: {
        utils(){
            return Utils;
        },
        uiPermissions(){
            return this.$store.getters['security/uiPermissions'];
        }
    },
    methods: {
        loadTanks(){
            this.$store.dispatch("generic/setLoading", true);
            this.tanks = [];
            this.details = [];
            this.selectedHeader = null;
            let filters = [
                {
                    operator: 'eq',
                    value: this.selectedTank.value,
                    property: 'Code'
                }
            ];
            let params = {
                filter: JSON.stringify(filters),
            }

            TankManagementService.getTanks(params, response => {
                if(Object.keys(this.selectedTank).length === 0){
                    this.$toast.add({detail: this.$t('tankManagement.toastLoadErrorMessage'), life:3000, severity:'error'});
                    this.$store.dispatch("generic/setLoading", false);
                }else{
                    if(response.success){
                        this.tanks = response.data;
                        this.$store.dispatch("generic/setLoading", false);
                        }else{
                        this.tanks = [];
                        this.$store.dispatch("generic/setLoading", false);
                    }
                }    
            })
        },
        onHeaderSelect(e){
            this.$store.dispatch("generic/setLoading", true);
            this.loadItems(e.data.id);
        },
        loadItems(headerId){
            this.details = [];  

            let filters = [
                {
                operator: 'eq',
                value: headerId,
                property: 'IdTmTank'
                }
            ];
            let params = {
                filter: JSON.stringify(filters),
            }

            TankManagementService.getDetails(params, response => {
                if(response.success){
                    this.details = response.data;
                    this.$store.dispatch("generic/setLoading", false);
                    }else{
                    this.details = [];
                    this.$store.dispatch("generic/setLoading", false);
                }
            })
        },
        onDownloadTemplate(){
            this.$store.dispatch("generic/setLoading", true);
            TankManagementService.downloadEmptyExcel({}, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');
                
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', Constants.tankManagement.EMPTY_FILE_NAME);
                    document.body.appendChild(fileLink);
                
                    fileLink.click();
                }
            });
        },
        onDeleteTank(){          
            this.$confirm.require({
                message:  this.$t('tankManagement.deleteMessage'),
                header:  this.$t('tankManagement.deleteHeader'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('tankManagement.acceptLabel'),
                rejectLabel: this.$t('tankManagement.rejectLabel'),
                accept: () => {
                    TankManagementService.deleteTank( this.selectedHeader.id ,response => {
                        if(response.success){
                        this.$toast.add({detail: this.$t('tankManagement.toastDeleteSuccesMessage'), life:3000, severity:'success'});
                        this.loadTanks();
                        }
                    });
                },
                reject: () => {
                    
                }
            });
        },
        onDownloadCalibrationTable(){
            if(Object.keys(this.selectedTank).length === 0){
                this.$toast.add({detail: this.$t('tankManagement.toastLoadErrorMessage'), life:3000, severity:'error'});
            }else{
                this.$store.dispatch("generic/setLoading", true);
                let tankCode = this.selectedTank.value;
                TankManagementService.downloadFilledExcel({
                    tankCode: tankCode
                }, response => {
                    this.$store.dispatch("generic/setLoading", false);
                    if(response.success){
                        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                        var fileLink = document.createElement('a');
                    
                        fileLink.href = fileURL;
                        fileLink.setAttribute('download', Constants.tankManagement.FILLED_FILE_NAME(tankCode));
                        document.body.appendChild(fileLink);
                    
                        fileLink.click();
                    }
                });
            }
        },
        onUploadDisplay(){
            this.uploadDisplay = true;
        },
        onDetailsDialog(data){
            this.detailsDisplay = true;   
            this.dialogData = data;            
            // for (var key in this.dialogData){
            //     if (typeof this.dialogData[key] !== 'function') {
            //         this.message = this.messageDialogProva + key;
            //         console.log(this.message);
            //     }
            // }
            //  messageDialogProva:'tankManagement',
            // {{messageDialogProva}}.{{key}} non è possibile richiamare il language.js
        },
        uploaderResponseMethod(file){
            let formData = new FormData();
            formData.append('formFile', file.files[0]);
         
            this.$store.dispatch("generic/setLoading", true);
            
            TankManagementService.uploadExcel(formData, response => {
                if(response.success){
                    this.$store.dispatch("generic/setLoading", false);
                    this.$toast.add({detail: this.$t('tankManagement.toastUploadSuccesMessage'), life:3000, severity:'success'});
                    this.loadTanks();
                 }else{
                    this.$store.dispatch("generic/setLoading", false);
                    this.$toast.add({detail: "Error: " + response.message, life:3000, severity:'error'});
                }
            })
        }
    },
}

</script>

<style>
.table-container{
    display: flex; 
    align-items: center; 
}
.resize-button-tool{
    height: 37px;
}
hr{
    border-top: 1px solid lightgrey;
}
.bold{
    font-weight: bold;
}

</style>

<template>
    <main>
    <Toolbar>
    <!-- TOOLBAR --> 
        <template #start>
            <div class="grid">
                <div class="col-9">
                    <GenericCustomMasterDataAutocompleteV2
                        v-model="selectedTank.value" 
                        name="tank-management-tank-combo"
                        api="tank-management/tank-combo"
                        class="w-full p-inputtext-sm"/>      
                </div>
                <div class="col-3">
                <ResponsiveButton :label="$t('tankManagement.load')" icon="pi pi-replay" class="mx-2 p-button-info" @click="loadTanks" :disabled="!uiPermissions('tankManagementLoadButton').isEnabled" />
            </div>
            <div class="col-12">
                <ResponsiveButton :label="$t('tankManagement.downloadTemplate')" icon="pi pi-download" class="mr-2 p-button-info" @click="onDownloadTemplate()" :disabled="!uiPermissions('tankManagementDownloadTemplateButton').isEnabled" />              
                <ResponsiveButton :label="$t('tankManagement.uploadTemplate')" icon="pi pi-upload" class="mr-2 p-button-success" @click="onUploadDisplay()" :disabled="!uiPermissions('tankManagementUploadTemplateButton').isEnabled"/>
                <ResponsiveButton :label="$t('tankManagement.deleteSelected')" icon="pi pi-trash" class="mr-2 p-button-danger"  @click="onDeleteTank()" :disabled="!uiPermissions('tankManagementDeleteButton').isEnabled || !selectedHeader"/>
                <ResponsiveButton :label="$t('tankManagement.downloadCalibrationTable')" icon="pi pi-file-excel" class="p-button-info " :disabled="!uiPermissions('tankManagementdownloadCalibrationButton').isEnabled || !selectedHeader" @click="onDownloadCalibrationTable()"/>
            </div>
            </div>
        </template>

    </Toolbar>
    <div class="grid">
        <div class="col-12">
        <hr>
        <!-- COMPONENTE GRIGLIA VERSIONI -->      
            <div class="card">
                <div class="grid">
                    <Card class="col-12" >                  
                        <template #content>
                            <DataTable :value="tanks" showGridlines stripedRows :reorderableColumns="true"
                            dataKey="id"
                            v-model:selection="selectedHeader" selectionMode="single" @rowSelect="onHeaderSelect">
                                <Column field="isActive" :header="$t('tankManagement.isActive')" style="width:10%; min-width:8rem" bodyStyle="text-align:center">
                                    <template #body="element">
                                        <i class="pi" :class="{'true-icon pi-check-circle': element.data.endDate == null}"></i>
                                    </template>
                                </Column>
                                <Column field="type" :header="$t('tankManagement.type')" dataType="string" :sortable="true">
                                    <template #body="element">
                                        {{element.data.type}}
                                    </template>
                                </Column>
                                <Column field="code" :header="$t('tankManagement.code')" dataType="string" :sortable="true">
                                    <template #body="element">
                                        {{element.data.code}}
                                    </template>
                                </Column>         
                                <Column field="startDate" :header="$t('tankManagement.startDate')" dataType="date" :sortable="true">
                                    <template #body="element">
                                        {{element.data.startDate != null ? utils.formatDate(utils.dateToCurrentTimeZone(element.data.startDate)) : null}}
                                    </template>
                                </Column>
                                <Column field="endDate" :header="$t('tankManagement.endDate')" dataType="date" :sortable="true">
                                    <template #body="element">
                                        {{element.data.endDate != null ? utils.formatDate(utils.dateToCurrentTimeZone(element.data.endDate)) : null}}
                                    </template>
                                </Column>
                                <Column field="plant" :header="$t('tankManagement.plant')" dataType="string" :sortable="true">
                                    <template #body="element">
                                        {{element.data.plant}}
                                    </template>
                                </Column>
                                <Column field="details" :header="$t('tankManagement.details')" style="width:10%; min-width:8rem" bodyStyle="text-align:center">
                                    <template #body="slotProps">
                                        <Button icon="pi pi-info" class="grid-action-btn p-button-rounded p-button-outlined" @click="onDetailsDialog(slotProps.data)"/>
                                    </template>
                                </Column>
                                <template #empty> 
                                    {{$t('noRecordsFound')}}
                                </template>
                                </DataTable>
                            
                        </template>
                    </Card>
                </div>
            </div>
        <!-- COMPONENTE GRIGLIA DETTAGLI -->
            <div class="card">
                <div class="grid">
                    <Card class="col-12" >
                        <template #content>
                            <DataTable :reorderableColumns="true" :value="details" :scrollable="true" scrollHeight="400px" showGridlines stripedRows>
                                <Column field="level" :header="$t('tankManagement.level')" dataType="number" :sortable="true">
                                    <template #body="element">
                                        {{element.data.level}}
                                    </template>
                                </Column>
                                <Column field="calibrationFactor" :header="$t('tankManagement.calibrationFactor')" dataType="number" :sortable="true">
                                    <template #body="element">
                                        {{element.data.calibrationFactor}}
                                    </template>
                                </Column>         
                                <Column field="volume" :header="$t('tankManagement.volume')" dataType="number" :sortable="true">
                                    <template #body="element">
                                        {{element.data.volume}}
                                    </template>
                                </Column>
                                <template #empty>
                                    {{$t('noRecordsFound')}}
                                </template>
                            </DataTable>
                        </template>
                    </Card>
                </div>
            </div> 
          <!-- DIALOG -->
            <Dialog v-model:visible="uploadDisplay">
                <template #header>
                    <h3>{{$t('tankManagement.uploadHeader')}}</h3>
                </template>
                     <FileUpload name="uploaded[]" :customUpload="true" @uploader="uploaderResponseMethod" :previewWidth="0" :fileLimit="1" :multiple="false" />                    
            </Dialog>   
            <Dialog v-model:visible="detailsDisplay">
                <template #header>
                    <h3>{{$t('tankManagement.details')}}</h3>
                </template>
                <div v-for="(value, key) of dialogData" :key="key" style="margin-bottom: 2px;">
                    <span class="bold"> {{key}}: </span>
                        <span v-if="value == null" style="color:red;">
                            null
                        </span>
                        <span v-else>
                            {{value}}
                        </span>
                </div>
            </Dialog>
        </div>
    </div>
    </main>
</template>
        